import { completedGradPagesMap } from "./ContinueApplicationGrads/constants";

export const GET_GRADUATES_APPLICATION_DATA = "GET_GRADUATES_APPLICATION_DATA";

export const GET_GRADUATES_APPLICATION_DATA_QUERY =
  "GET_GRADUATES_APPLICATION_DATA_QUERY";

export const FORM_VALIDATION_ERROR_CODE = 400;

export enum GraduatesEndpoints {
  AboutYou = "aboutyou",
  Details = "details",
}

export const gradsFormNavigationMap = {
  [GraduatesEndpoints.Details]: completedGradPagesMap[22],
  [GraduatesEndpoints.AboutYou]: completedGradPagesMap[2],
};
